<template>
  <section class="login">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div
          class="content-wrapper d-flex align-items-center auth auth-bg-1 theme-one"
        >
          <div class="row w-100">
            <div class="col-lg-5 col-xl-4 offset-xl-1 my-auto">
              <!-- <h1 style="color:white; text-align:center">Pixan Cloud</h1> -->
              <div class="auto-form-wrapper">
                <div
                  v-if="!muestraFormDatos"
                  class="logo-login text-center mb-5 "
                >
                  <img src="@/assets/images/logo-login@2x.svg" alt="logo" />
                </div>
                <div
                  class="logo-login text-center mb-4 pl-5"
                  v-if="muestraFormDatos"
                >
                  <img src="@/assets/images/logo-registro.svg" alt="logo" />
                </div>
                <slot name="formulario"></slot>
                <b-alert variant="danger" :show="Boolean(error)">{{
                  error
                }}</b-alert>
              </div>
              <ul class="auth-footer">
                <li>
                  <a
                    href="https://pixancloud.com/aviso-de-privacidad.html"
                    target="_blank"
                    >Aviso de privacidad</a
                  >
                </li>

                <li>
                  <a
                    href="https://pixancloud.com/terminos-y-condiciones.html"
                    target="_blank"
                    >Términos y condiciones</a
                  >
                </li>
              </ul>
              <p class="footer-text text-center">
                Copyright © 2022 Pixan Cloud.
              </p>
            </div>
          </div>
        </div>
        <!-- content-wrapper ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      muestraFormDatos: false
    };
  },
  props: ["error"]
};
</script>

<style scoped>
/*.login {
}*/
</style>



// WEBPACK FOOTER //
// src/vistas/Auth/FormBase.vue